import { environment } from 'src/environments/environment';
import { HttpService } from '@sdbn/appclient';
import { Component, OnInit, Inject } from '@angular/core';
import { ResponseMessage } from '@sdbn/appclient';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { TranslationService } from '@sdbn/common';
import { ServiceResponse } from '@sdbn/appclient';

import { ResponseStatus } from '@sdbn/appclient';
import { TMCClientParameters } from 'src/tmc-common/tmc-client-parameters';
import { ConfigurationService } from '@sdbn/appclient';
import { TransportStationAssignment, BeginUmbrueckung, UmbrueckungDetails } from '../../model/sac-client.model';
import { TransportScope } from 'src/tmc-yard/common/model/transport.model';

@Component({
  selector: 'app-sac-begin-umbrueckung-dialog',
  templateUrl: './sac-begin-umbrueckung-dialog.component.html',
  styleUrls: ['./sac-begin-umbrueckung-dialog.component.scss']
})
export class SacBeginUmbrueckungDialogComponent implements OnInit {

  sourceTransportAssignment: TransportStationAssignment;
  targetTransportAssignment: TransportStationAssignment;

  details = new UmbrueckungDetails({});

  responseMessages: ResponseMessage[];
  isLoading = false;

  umbrueckungPossible = false;

  constructor(
    public configurationService: ConfigurationService,
    public dialogRef: MatDialogRef<SacBeginUmbrueckungDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private httpService: HttpService,
    public translationService: TranslationService
  ) {
    this.sourceTransportAssignment = data.sourceTransportAssignment;
    this.targetTransportAssignment = data.targetTransportAssignment;
  }

  ngOnInit() {

    this.httpService.postWithContext<UmbrueckungDetails>(environment.sacClientEndpoint + '',
      [this.sourceTransportAssignment, this.targetTransportAssignment]).subscribe(
        details => {
          if (details.status !== ResponseStatus.SUCCESS) {
            this.responseMessages = details.responseMessages;
            this.umbrueckungPossible = false;
          } else {
            this.details = new UmbrueckungDetails(details);
            this.umbrueckungPossible = true;
          }
        }
      );
  }

  public isCloseDialogDisabled() {
    return false;
  }

  public closeDialog() {
    this.dialogRef.close();
  }

  public beginUmbrueckung() {

    const request = new BeginUmbrueckung();
    request.sourceTransport = { id: this.sourceTransportAssignment.transport.id };
    request.sourceTransportStationId = { id: this.sourceTransportAssignment.station.id };

    request.targetTransport = { id: this.targetTransportAssignment.transport.id };
    request.targetTransportStationId = { id: this.targetTransportAssignment.station.id };

    request.swapTrailerNumber = this.details.swapTrailerNumber;
    request.trailerNumberPlate = this.details.trailerNumberPlate;

    this.httpService.postWithContext<ServiceResponse>(environment.sacClientEndpoint + '/begin-umbrueckung', request).subscribe(
      response => {
        if (response.status !== ResponseStatus.SUCCESS) {
          this.responseMessages = response.responseMessages;
        } else {
          this.dialogRef.close();
        }
      },
      error => {
        console.log('Unexpexted Error: ', error);
      }
    );
  }

  public isBeginUmbrueckungDisabled() {

    if (!this.umbrueckungPossible) {
      return true;
    }

    if (this.isTrailerNumberPlateRequired()
      && (this.details.trailerNumberPlate == null || this.details.trailerNumberPlate.length === 0)) {
      return true;
    }

    if (this.isSwapTrailerNumberRequired()
      && (this.details.swapTrailerNumber == null || this.details.swapTrailerNumber.length === 0)) {
      return true;
    }

  }

  public isTrailerNumberPlateRequired(): boolean {
    return this.details.targetTransportScope === TransportScope.TRAILER;
  }

  public isTrailerNumberVisible(): boolean {
    return this.details.targetTransportScope === TransportScope.TRAILER;
  }

  public isSwapTrailerNumberRequired(): boolean {
    if (this.isSwapTrailerEnabled()) {
      return this.details.targetTransportScope === TransportScope.SWAP_TRAILER;
    }
    return false;
  }

  public isSwapTrailerEnabled(): boolean {
    return this.configurationService.isEnabled(TMCClientParameters.P_VISITS_ATTACH_DETACH_SWAP_TRAILER_ENABLED, false);
  }

}

